import React from "react";
import { Switch, Tag } from "antd";
import { CrownFilled } from "@ant-design/icons";

import { MODULES } from "../../constants/modules";
import styles from "./styles.module.css";

/**
 * The optional parts of the panel, as a list you tick.
 *
 * The same control serves both places it is asked for: the setup screen, where
 * nothing exists yet and the answer is stored the moment the workspace is
 * created, and فضای کاری › ماژول‌ها, where it changes a workspace already in
 * use. Two copies of this list would drift the day a module is added.
 *
 * The «بزودی» entries are rendered and not selectable on purpose. Leaving them
 * out would make the list look like the whole product; showing them as
 * disabled is how someone finds out نامه‌نگاری is coming without us mailing
 * them about it.
 */
const ModulePicker = ({
  value = [],
  onChange,
  onLocked,
  disabled = false,
  subscriptionLocked = false,
}) => {
  const toggle = (key, next) => {
    const set = new Set(value);
    if (next) set.add(key);
    else set.delete(key);
    onChange?.([...set]);
  };

  return (
    <ul className={styles.list}>
      {MODULES.map((item) => {
        const checked = value.includes(item.key);
        const premiumLocked = subscriptionLocked && !item.comingSoon;
        const locked = disabled || premiumLocked || item.comingSoon;

        return (
          <li
            key={item.key}
            className={`${styles.item} ${checked ? styles.itemOn : ""} ${
              item.comingSoon ? styles.itemSoon : ""
            } ${premiumLocked ? styles.itemPremium : ""}`}
            onClick={premiumLocked ? () => onLocked?.(item) : undefined}
          >
            <label className={styles.body} htmlFor={`module-${item.key}`}>
              <span className={styles.head}>
                <span className={styles.title}>{item.label}</span>
                {item.comingSoon && (
                  <Tag bordered={false} className={styles.soonTag}>
                    بزودی
                  </Tag>
                )}
              </span>
              <span className={styles.description}>{item.description}</span>
            </label>

            {premiumLocked ? (
              <button
                type="button"
                className={styles.crown}
                aria-label={item.label}
                onClick={(event) => {
                  event.stopPropagation();
                  onLocked?.(item);
                }}
              >
                <CrownFilled />
              </button>
            ) : (
              <Switch
                id={`module-${item.key}`}
                size="small"
                disabled={locked}
                checked={item.comingSoon ? false : checked}
                onChange={(next) => toggle(item.key, next)}
                aria-label={item.label}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default ModulePicker;
